import React from 'react';
import PaymentReportsAll from './index';

const ProrabPaymentsReport = () => {
  return (
    <PaymentReportsAll isProrabPage/>
  );
};

export default ProrabPaymentsReport;